module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 考级测试")])], 1), _vm._v(" "), _c('el-alert', {
    staticClass: "elalert",
    attrs: {
      "title": "温馨提示",
      "type": "warning"
    }
  }, [_vm._v("\n      1.请根据自己的身份选择不同的考试类型"), _c('br'), _vm._v("\n      2.游客身份可以测试客观题，不可以测试实践题。"), _c('br'), _vm._v("\n      3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。"), _c('br')]), _vm._v(" "), _c('el-steps', {
    staticClass: "elsteps",
    attrs: {
      "space": 200,
      "active": 4,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "报名信息"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "理论测试"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "实践考试"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "考级结果"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "查看证书"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, [_c('div', {
    staticClass: "container_left_content"
  }, [_c('div', {
    staticClass: "container_left_content_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.user.face
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("姓名：")]), _vm._v(_vm._s(_vm.row.user.name) + "\n          ")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (_vm.row.status == 5) ? _c('div', {
    staticClass: "container_center"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "container_center_des"
  }, [_vm._v("\n          等候评委在7个工作日内的审核，最终考试结果，将在您的考级申报窗口显示并同时用站内信箱显示，祝您成功！\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "container_center_goback"
  }, [_c('el-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        path: '/indexpc'
      }),
      expression: "{ path: '/indexpc' }"
    }],
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("返回首页")])], 1)]) : (_vm.row.status == 6) ? _c('div', {
    staticClass: "container_center"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "container_center_des"
  }, [_vm._v("\n          经专家评审，恭喜您考级顺利过关，获得“" + _vm._s(_vm.row.grade) + "”级别。请查看您的电子证书。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "container_center_goback"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.cert.url,
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("查看证书")])], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看证书",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.cert.url
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下载打印证书")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goPost
    }
  }, [_vm._v("申请原件")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("实践题：")]), _vm._v("《实践题题目》\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_center_upsuccess"
  }, [_c('i', {
    staticClass: "el-icon-success"
  }), _vm._v("上传成功\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_center_upsuccess"
  }, [_c('i', {
    staticClass: "el-icon-success"
  }), _vm._v("考级成功\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe180542","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/kaoji/KaojiApplyStep6.vue
// module id = 1350
// module chunks = 0